module.exports = __webpack_public_path__ + "static/Pt04-removebg-preview-d9eeb8754a6a9bec19b9a0734a0e80dc.png";